import React, { useState, useEffect } from 'react';
import { Box, Dialog, DialogTitle, DialogContent, Typography, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { Capacitor } from '@capacitor/core';

const AppStoreButtons = () => {
  const { t, i18n } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedStore, setSelectedStore] = useState('');
  const [isNativePlatform, setIsNativePlatform] = useState(false);

  // 플랫폼 감지
  useEffect(() => {
    const checkPlatform = () => {
      const platform = Capacitor.getPlatform();
      const isNative = platform === 'ios' || platform === 'android';
      setIsNativePlatform(isNative);
      
      if (isNative) {
        console.log(`📱 [AppStoreButtons] 네이티브 플랫폼 감지 (${platform}) - 앱스토어 버튼 숨김`);
      } else {
        console.log(`🌐 [AppStoreButtons] 웹 플랫폼 감지 (${platform}) - 앱스토어 버튼 표시`);
      }
    };
    
    checkPlatform();
  }, []);

  const handleStoreClick = (storeType) => {
    setSelectedStore(storeType);
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
    setSelectedStore('');
  };

  // 네이티브 플랫폼에서는 아무것도 렌더링하지 않음
  if (isNativePlatform) {
    return null;
  }

  return (
    <>
      <Box 
        sx={{ 
          display: 'flex',
          flexDirection: 'row',
          gap: { xs: 2, sm: 3 },
          justifyContent: 'center',
          alignItems: 'center',
          my: { xs: 4, sm: 5 },
          px: 2
        }}
      >
        {/* Apple App Store Button - 먼저 배치 */}
        <Box
          onClick={() => handleStoreClick('apple')}
          sx={{
            cursor: 'pointer'
          }}
        >
          <img
            src="/download-on-the-app-store.svg"
            alt="Download on the App Store"
            style={{
              height: window.innerWidth <= 600 ? '32px' : '48px',
              width: 'auto',
              display: 'block'
            }}
          />
        </Box>

        {/* Google Play Store Button */}
        <Box
          onClick={() => handleStoreClick('google')}
          sx={{
            cursor: 'pointer'
          }}
        >
          <img
            src="/GetItOnGooglePlay_Badge_Web_color_English.png"
            alt="Get it on Google Play"
            style={{
              height: window.innerWidth <= 600 ? '32px' : '48px',
              width: 'auto',
              display: 'block'
            }}
          />
        </Box>
      </Box>

      {/* Coming Soon Modal */}
      <Dialog 
        open={modalOpen} 
        onClose={handleClose}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            p: 1
          }
        }}
      >
        <DialogTitle sx={{ 
          display: 'flex', 
          justifyContent: 'flex-end', 
          alignItems: 'center',
          pb: 1
        }}>
          <IconButton onClick={handleClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        
        <DialogContent sx={{ pt: 1 }}>
          <Box sx={{ textAlign: 'center', py: 2 }}>
            <Typography 
              variant="h6" 
              sx={{ 
                mb: 2, 
                fontWeight: 'bold',
                whiteSpace: 'pre-line'
              }}
            >
              {selectedStore && t(`appStore.${selectedStore}ComingSoon`)}
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              {t('appStore.comingSoonMessage')}
            </Typography>
            <Button 
              variant="contained" 
              onClick={handleClose}
              sx={{ 
                borderRadius: 2,
                px: 4,
                py: 1
              }}
            >
              {t('common.confirm')}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AppStoreButtons; 